
import { georgeMediaArray } from './georgeMedia'
import { elaineReviewerProfile, jerryReviewerProfile, kramerReviewerProfile } from './georgeReviewers'
import { kramerBio, elaineBio, jerryBio, georgeBio } from './georgeBios'
import { georgeDatingProfileHinge, georgeDatingProfileBumble, georgeDatingProfileTinder } from './georgeDatingProfiles'

export const georgeUser = {
  _id: 'georgeUserId',
  email: 'george@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...elaineReviewerProfile },
    { ...jerryReviewerProfile },
    { ...kramerReviewerProfile }
  ],
  media: [ ...georgeMediaArray ],
  bio: { ...georgeBio },
  datingProfiles: [
    { ...georgeDatingProfileHinge },
    { ...georgeDatingProfileBumble },
    { ...georgeDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const elaineUser = {
  _id: 'elaineUserId',
  email: 'elaine@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...elaineBio },
  datingProfiles: [],
  reviewerProfile: { ...elaineReviewerProfile },
}

export const jerryUser = {
  _id: 'jerryUserId',
  email: 'jerry@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...jerryBio },
  datingProfiles: [],
  reviewerProfile: { ...jerryReviewerProfile },
}

export const kramerUser = {
  _id: 'kramerUserId',
  email: 'kramer@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...kramerBio },
  datingProfiles: [],
  reviewerProfile: { ...kramerReviewerProfile },
}
